import { LockQuestionIcon } from './LockQuestionIcon';

/**
 * author: Simran
 * id 390C2479-98DD-46FB-AA39-CD816E7982C8
 * name lock-question
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-question.svg
 * tags
 * - Lock 
 */
export const PasswordQuestionIcon = LockQuestionIcon;
export default PasswordQuestionIcon